const SECOND_IN_MILLI_SECOND = 1000;
const MINUTE_IN_MILLI_SECOND = SECOND_IN_MILLI_SECOND * 60;
const HOUR_IN_MILLI_SECOND = MINUTE_IN_MILLI_SECOND * 60;
const DAY_IN_MILLI_SECOND = HOUR_IN_MILLI_SECOND * 24;

function toShortDate(date: number | Date | undefined, format = 'en-ca') {
  return new Intl.DateTimeFormat(format).format(date);
}

function getDateTimeToIsoString({
  date = new Date(),
  hour = 0,
  min = 0,
  sec = 0,
  ms = 0,
}: {
  date: Date;
  hour: number;
  min?: number;
  sec?: number;
  ms?: number;
}) {
  return new Date(
    date.setHours(hour, min, sec, ms) - new Date().getTimezoneOffset() * 60000
  ).toISOString();
}

function getTimeDifference({
  startTime = new Date().getTime(),
  endTime,
}: {
  startTime?: number;
  endTime: number;
}) {
  const difference = endTime - startTime;

  const days = Math.floor(difference / DAY_IN_MILLI_SECOND);

  let hours: string | number = Math.floor(
    (difference % DAY_IN_MILLI_SECOND) / HOUR_IN_MILLI_SECOND
  );
  let minutes: string | number = Math.floor(
    (difference % HOUR_IN_MILLI_SECOND) / MINUTE_IN_MILLI_SECOND
  );
  let seconds: string | number = Math.floor(
    (difference % MINUTE_IN_MILLI_SECOND) / SECOND_IN_MILLI_SECOND
  );

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;

  return {
    differenceInString: `${hours}:${minutes}:${seconds}`,
    differenceInNumber: difference,
    differenceInDays: days,
  };
}

export { toShortDate, getTimeDifference, getDateTimeToIsoString };
